<template>
  <div
    ref="containerEl"
    :class="['ScrollOverflow', { isHorizontal, isVertical, isContained, isMobile, isDesktop: !isMobile }]"
    v-bind="$attrs"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { isMobile } from '@/core/helpers/ui.helper';
import { ref } from 'vue';

interface Props {
  isVertical?: boolean;
  isHorizontal?: boolean;
  isContained?: boolean;
}

withDefaults(defineProps<Props>(), {});

const containerEl = ref<HTMLDivElement>();
const resetScroll = () => {
  if (!containerEl.value) return;

  containerEl.value.scrollTop = 0;
};

interface ScrollToBottomOptions {
  top?: number;
  bottom?: boolean;
  behavior?: 'instant' | 'smooth';
}
const scrollTo = (options?: ScrollToBottomOptions) => {
  if (!containerEl.value) return;

  if (options?.top) {
    containerEl.value.scrollTo({
      top: options.top,
      behavior: options?.behavior,
    });
  } else if (options?.bottom) {
    containerEl.value.scrollTo({
      top: containerEl.value.scrollHeight,
      behavior: options?.behavior,
    });
  }
};

defineExpose({
  resetScroll,
  scrollTo,
});
</script>

<style lang="scss" scoped>
.ScrollOverflow {
  overflow-x: hidden;
  overflow-y: hidden;

  &.isHorizontal {
    overflow-x: auto;
  }

  &.isHorizontal::-webkit-scrollbar {
    display: none;
  }

  &.isVertical {
    overflow-y: auto;

    :deep(.icon-container) {
      display: none;
    }
  }

  &.isContained {
    overscroll-behavior: contain;
  }
}

.ScrollOverflow.isMobile {
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.ScrollOverflow.isDesktop {
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
